import script from "./ListSort.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListSort.vue?vue&type=script&lang=ts&setup=true"

import "./ListSort.vue?vue&type=style&index=0&id=9723231c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9723231c"]])

export default __exports__